import styles from '@/pages/app/BillingOps/styles.module.scss'

import { CommitResponse } from '@/api/generated'
import { stripeDashboardUrl } from '@/utils/stripe'

const extractInvoiceId = (response: object): string | null => {
  if (response && typeof response === 'object' && 'id' in response) {
    const id = (response as { id: unknown }).id
    if (typeof id === 'string' && id.startsWith('in_')) return id
  }
  return null
}

interface CommitResultPanelProps {
  result: CommitResponse
  onRunAnother: () => void
}

const CommitResultPanel = ({ result, onRunAnother }: CommitResultPanelProps) => {
  const invoiceIds = Array.from(
    new Set(result.stripe_responses.map((r) => extractInvoiceId(r as object)).filter((id): id is string => id !== null))
  )

  return (
    <div className={styles.panel}>
      <div className={styles.section}>
        <h2 className={styles.sectionTitle}>Done</h2>
        <p className={styles.summary}>
          Operation committed. {result.stripe_responses.length} Stripe response
          {result.stripe_responses.length === 1 ? '' : 's'}.
        </p>

        {invoiceIds.length > 0 && (
          <div>
            <h3 className={styles.label}>Invoices</h3>
            <ul className={styles.list}>
              {invoiceIds.map((id) => (
                <li key={id}>
                  <a
                    className={styles.artifactStripeLink}
                    href={stripeDashboardUrl(id)}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {id}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        )}

        <details className={styles.rawJsonDetails}>
          <summary>Raw Stripe response (for engineer handoff)</summary>
          <pre>{JSON.stringify(result.stripe_responses, null, 2)}</pre>
        </details>

        <div className={styles.actionRow}>
          <button type="button" className={styles.opItem} onClick={onRunAnother}>
            <span className={styles.opItemKind}>Run another</span>
          </button>
        </div>
      </div>
    </div>
  )
}

export default CommitResultPanel
